import * as api from "./middleware/api.middleware";

export function getRefreshToken(refreshtoken: string, username: string) {
  const getResponse = api.post<any>(`token/refresh`, {
    email: username,
    refresh_token: refreshtoken,
  });
  return getResponse;
}
